import * as React from "react";
import { PermissionRoute } from "../../../Common/Routing/PermissionRoute";

const SpecialReports = React.lazy(() => import("./SpecialReports"));
const InventoryAtDate = React.lazy(() => import("./InventoryAtDate"));
const SlowMovingStock = React.lazy(() => import("./SlowMovingStock"));
const LastStocktaked = React.lazy(() => import("./LastStocktaked"));
const RevisionHistoryReport = React.lazy(() => import("./RevisionHistoryReport"));
const MetcashMSCReport = React.lazy(
    () => import("./MetcashMSCReport").then(component => ({ default: component.MetcashMSCReport }))
);
const InventoryMovementReport = React.lazy(() => import("./InventoryMovementReport"));

export default function SpecialReportingIndex(): Array<React.ReactNode> {
    return [
        <PermissionRoute
            title="Miscellaneous Reports | Shopfront"
            permissions={[]}
            path="/reports/misc"
            key="special-reports"
            element={<SpecialReports />}
        />,
        <PermissionRoute
            title="Inventory at Date Report | Shopfront"
            permissions={[ "run_inventory_reports" ]}
            path="/reports/misc/inventory-at-date"
            key="special-report-inventory-at-date"
            element={<InventoryAtDate />}
        />,
        <PermissionRoute
            title="Slow Moving Stock Report | Shopfront"
            permissions={[ "run_inventory_reports", "run_sales_reports" ]}
            path="/reports/misc/slow-moving-stock"
            key="special-report-slow-moving"
            element={<SlowMovingStock />}
        />,
        <PermissionRoute
            title="Last Stocktaked Report | Shopfront"
            permissions={[ "run_sales_reports" ]}
            path="/reports/misc/last-stocktaked"
            key="special-report-last-stocktaked"
            element={<LastStocktaked />}
        />,
        <PermissionRoute
            title="Product Revision History Report | Shopfront"
            permissions={[ "run_actions_reports" ]}
            path="/reports/misc/revisions/:id"
            key="special-report-revision-history-with-id"
            element={<RevisionHistoryReport />}
        />,
        <PermissionRoute
            title="Product Revision History Report | Shopfront"
            permissions={[ "run_actions_reports" ]}
            path="/reports/misc/revisions"
            key="special-report-revision-history"
            element={<RevisionHistoryReport />}
        />,
        <PermissionRoute
            title="Metcash MSC Report | Shopfront"
            permissions={[ "run_sales_reports" ]}
            path="/reports/misc/metcash/msc"
            element={<MetcashMSCReport />}
            key="special-report-metcash-msc"
        />,
        <PermissionRoute
            title="Inventory Movement Report | Shopfront"
            permissions={[ "run_inventory_reports" ]}
            path="/reports/misc/inventory-movement/:id"
            key="special-report-inventory-movement-with-id"
            element={<InventoryMovementReport />}
        />,
        <PermissionRoute
            title="Inventory Movement Report | Shopfront"
            permissions={[ "run_inventory_reports" ]}
            path="/reports/misc/inventory-movement"
            element={<InventoryMovementReport />}
            key="special-report-inventory-movement"
        />,
    ];
}
